import React, { useEffect, useState, Component } from 'react';
/**
 * Desktop Component
 * Main OS container with background and window management
 */
import { AnimatePresence } from 'framer-motion';
import { useTheme } from '../../core/contexts/ThemeContext';
import { useWindows } from '../../core/contexts/WindowContext';
import { useAppRegistry } from '../../core/contexts/AppRegistry';
import { Window } from './Window';
import { Dock } from './Dock';
import { AppInitializer } from './AppInitializer';
import { DesktopWidgets } from './Widgets/DesktopWidgets';
import { BootSequence } from './BootSequence';
export function Desktop() {
  const {
    getThemeClasses
  } = useTheme();
  const {
    windows
  } = useWindows();
  const {
    getAppById
  } = useAppRegistry();
  const theme = getThemeClasses();
  const [isBooting, setIsBooting] = useState(true);
  const handleBootComplete = () => {
    setIsBooting(false);
  };
  return <div className={`w-full min-h-screen ${theme.bg} ${theme.text} relative overflow-hidden`} data-id="element-872">
      {/* Boot Sequence */}
      <AnimatePresence data-id="element-873">
        {isBooting && <BootSequence onComplete={handleBootComplete} data-id="element-874" />}
      </AnimatePresence>
      {/* Initialize apps on mount */}
      <AppInitializer data-id="element-875" />
      {/* Background Pattern/Noise - subtle texture */}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZmlsdGVyIGlkPSJub2lzZSI+PGZlVHVyYnVsZW5jZSB0eXBlPSJmcmFjdGFsTm9pc2UiIGJhc2VGcmVxdWVuY3k9IjAuOSIgbnVtT2N0YXZlcz0iNCIvPjwvZmlsdGVyPjxyZWN0IHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbHRlcj0idXJsKCNub2lzZSkiIG9wYWNpdHk9IjAuNSIvPjwvc3ZnPg==')]" data-id="element-876" />
      {/* Desktop Widgets - ALWAYS visible (Home screen) */}
      {!isBooting && <DesktopWidgets data-id="element-877" />}
      {/* Windows - appear on top of desktop */}
      {!isBooting && <AnimatePresence data-id="element-878">
          {windows.map(window => {
        const app = getAppById(window.appId);
        if (!app) return null;
        const AppComponent = app.component;
        return <Window key={window.id} window={window} data-id="element-879">
                <AppComponent projectId={window.projectId} data-id="element-880" />
              </Window>;
      })}
        </AnimatePresence>}
      {/* Dock */}
      {!isBooting && <Dock data-id="element-881" />}
    </div>;
}